import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Button } from "@src/stories/elements/Button/Button";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";
import "./Banner.scss";
import BannerImage from "./Image/BannerImage";
import BannerVideo from "./Video/BannerVideo";

export const Banner = ({ banners, useCarousel = true, section_settings, props }) => {
  const isMobile = useMobileBreakpoint(section_settings.mobile_breakpoint);
  const carouselRefBanner: any = useRef(null);
  const [parentHeight, setParentHeight] = useState(0);
  const [showStickyButton, setShowStickyButton] = useState(false);
  const moveDotsAboveOverlay = false;
  const showNavigation = isMobile
    ? section_settings.show_buttons_mobile
    : section_settings.show_buttons;

  const { globals } = props;

  let showButtons = section_settings.show_buttons;
  if (isMobile) {
    showButtons = section_settings.show_buttons_mobile;
  }

  let showDots = section_settings.show_indicators;
  if (isMobile) {
    showDots = section_settings.show_indicators_mobile;
  }



  useEffect(() => {
    if (!isMobile || !carouselRefBanner.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        // Show sticky button when banner is not visible (scrolled past)
        setShowStickyButton(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px'
      }
    );

    observer.observe(carouselRefBanner.current);

    return () => {
      if (carouselRefBanner.current) {
        observer.unobserve(carouselRefBanner.current);
      }
    };
  }, [isMobile]);

  return (
    <div
      className={`banner ${section_settings.mobile_height > 0 && `h-[${section_settings.mobile_height}px]`} ${section_settings.is_primary && "lg:h-[87vh]"}`}
      style={!isMobile ? { height: 'calc(-112.889px + 100vh)' } : {}}
    >
      {(showNavigation && section_settings.use_carousel) && (
        <div className={"banner-carousel__controls"}>
          <CarouselNavigation
            shiftPageDots={false}
            carouselRef={carouselRefBanner}
            spread={true}
            icons={globals.carousel_icons}
            size={globals.carousel_icons?.carousel_navigation_arrow_size}
          />
        </div>
      )}

      <div
        className={"carousel banner-carousel h-full"}
        {...(useCarousel && {
          "x-data": "extended_carousel",
          "x-init": `$nextTick(() => { initialise(true, false, false, false, ${section_settings.autoplay_speed * 1000}, 'banner', false) })`,
          "x-ref": "carousel",
        })}
        ref={carouselRefBanner}
      >
        {banners.map((blockItem, index) => {
          return (
            <div key={index}>
              {blockItem.type === "block_image" && (
                <BannerImage
                  section_settings={section_settings}
                  blockItem={blockItem}
                  isMobile={isMobile}
                  isLazy={index !== 0}
                />
              )}
              {blockItem.type === "block_video" && (
                <BannerVideo
                  section_settings={section_settings}
                  blockItem={blockItem}
                  isMobile={isMobile}
                  banners={banners}
                  index={index}
                  globals={globals}
                />
              )}
            </div>
          );
        })}
      </div>


      {isMobile && showStickyButton && section_settings?.sticky_button_text && (
        <div className="banner_overlay_cta_sticky flex justify-center fixed bottom-0 left-0 right-0 z-50 p-4 shadow-lg">
          <Button
                style={section_settings?.sticky_button_style}
                width={section_settings?.sticky_button_width_mobile }
                padding_horizontal={section_settings?.sticky_button_padding_horizontal_mobile }
                padding_vertical={section_settings?.sticky_button_padding_vertical_mobile  }
                icon={section_settings?.sticky_button_icon}
                label={section_settings?.sticky_button_text}
                link={section_settings?.sticky_button_url}
                reverse={section_settings?.sticky_button_reverse_icon}
                onClick={undefined}
          />
        </div>
      )}
    </div>
  );
};
